module.exports = __webpack_public_path__ + "static/media/anime.4c484596.mp4";